import request from '@/utils/request2';
export function policyBatchList(data) {
  return request.post('admin/policy-batch/list', data);
}
export function policyBatchSave(data) {
  return request.post('admin/policy-batch/save-batch-policy', data);
}
export function policyBatchCheckField(data) {
  return request.post('admin/policy-batch/check-field', data);
}
export function policyBatchDetail(data) {
  return request.post('admin/policy-batch/batch-detail', data);
}
export function payBatchPolicy(data) {
  return request.post('admin/policy-batch/pay-batch-policy', data);
}
export function failBatchDetail(data) {
  return request.post('admin/policy-batch/fail-batch-detail', data);
}
export function failBatchPolicy(data) {
  return request.post('admin/policy-batch/fail-batch-policy', data);
}
export function getBatchPolicy(data) {
  return request.post('admin/policy-batch/get-batch-policy', data);
}